module.exports = __webpack_public_path__ + "img/logo-default.0d447be2.png";